<template lang="">
	<ParentForm
		v-if="personalInfo"
		:title="$route.name == 'userDetail' ? '': $siteconf.cooptation ? $t('coopInfoPer') : $t('infoGen.formText')"
		headerClass="pb-2"
		:disabled="isDisabled"
		@update="editform($event)"
	>
		<span>
			<span
				v-if="$route.name == 'userDetail'"
				class="pb-4"
			>
				<span
					class="text-success"
					v-if="checkAccount?.done"
				> {{ $t(`vCompte`) }}</span>
				<span
					class="sectionTitle "
					v-else
				>
					<MatButton
						v-if="checkAccount?.retry && !alreadysend && !$toMove.isSendLinkClicked"
						class="conditionLink "
						:label="$t(`vrCompte`)"
						outlined
						@click="verifyAccount"
					/>
					<MatButton
						v-else
						:label="$t(`avCompte`)"
						class="conditionLink "
						disabled
						outlined
					/>
				</span>
			</span>

			<div
				class="d-flex my-3 flex-wrap flex-sm-nowrap mb-4"
				v-if="$route.name == 'userDetail'"
			>
				<MatInput
					disabled
					class="me-3 mb-4 mb-sm-0"
					dense
					v-model="personalInfo.email"
					:label="$t('addMail')"
				/>
				<MatInput
					:class="{'pe-none': isDisabled}"
					:required="$siteconf.contact_choice == 'both' || $siteconf.contact_choice == 'phone'"
					:label="$t('mail-phone.phone')"
					dense
					v-model="personalInfo.phone"
					class="pe-3"
				/>
			</div>
			<div
				class="d-flex flex-wrap flex-sm-nowrap mb-4"
			>
				<MatInput
					class="me-0 me-sm-3 mb-4 mb-sm-0"
					dense
					v-model="personalInfo.firstName"
					:label="$t('infoGen.prenom')"
					required
					:class="{'pe-none': isDisabled}"
				/>
				<MatInput
					dense
					v-model="personalInfo.lastName"
					:label="$t('infoGen.nom')"
					required
					:class="{'pe-none': isDisabled}"
				/>
			</div>
			<div
				class="d-flex mb-4"
				v-if="$siteconf.accounts && ['both', 'phone'].includes($siteconf.contact_choice) && $route.name != 'userDetail'"
			>
				<MatInput
					dense
					v-model="personalInfo.phone"
					:required="$siteconf.contact_choice == 'both' || $siteconf.contact_choice == 'phone'"
					:label="$t('mail-phone.phone')"
					type="tel"
					name="phone"
					:class="{'pe-none': isDisabled}"
				/>
			</div>
			<div
				class="d-flex flex-wrap flex-sm-nowrap "
				:class="$siteconf?.hide_fields?.birthday && $siteconf?.hide_fields?.gender ? 'mb-0':'mb-4'"
			>
				<MatDatepicker
					v-if="!$siteconf?.hide_fields?.birthday"
					dense
					v-model="personalInfo.birthday"
					:label="$t('infoGen.naissance')"
					:required="$siteconf?.mandatory_fields?.birthday"
					:class="{'pe-none': isDisabled, 'mb-4 mb-sm-0':$siteconf?.hide_fields?.birthday || !$siteconf?.hide_fields?.gender}"
					:maxDate="$siteconf?.mandatory_fields?.birthday ? maxDate:null"
				/>
				<MatSelect
					v-if="!$siteconf?.hide_fields?.gender"
					v-model="personalInfo.gender"
					class="w-100"
					dense
					:label="$t('infoGen.gender')"
					:required="$siteconf?.mandatory_fields?.gender"
					:class="{'pe-none': isDisabled , 'ms-0 ms-sm-3' : !$siteconf?.hide_fields?.birthday }"
				>
					<MatListItem
						v-for="val in genders"
						:key="val.key"
						:value="val.key"
						:label="$t('genders.'+val.key)"
						:class="{'pe-none': isDisabled}"
					/>
				</MatSelect>
			</div>
			<div class="d-flex flex-wrap flex-sm-nowrap mb-4">
				<MatSelect
					v-model="personalInfo.country"
					class="me-0 me-sm-3 mb-4 mb-sm-0 w-100"
					dense
					:label="$t('infoGen.pays')"
					:required="$siteconf?.mandatory_fields?.country"
					:class="{'pe-none': isDisabled}"
				>
					<MatListItem
						v-for="val in countries"
						:key="val.key"
						:value="val.key"
						:label="$t('countries.'+val.key)"
					/>
				</MatSelect>
				<MatInput
					v-model="personalInfo.cp"
					dense
					:label="$t('infoGen.cp')"
					:type="cp.type || 'number'"
					:minlength="cp.minLen"
					:maxlength="cp.maxLen"
					:Pattern="cp.rx"
					class="me-0 me-sm-3 mb-4 mb-sm-0"
					:required="$siteconf?.mandatory_fields?.zipcode"
					:class="{'pe-none': isDisabled}"
				/>
				<MatInput
					v-model="personalInfo.city"
					dense
					class="me-0"
					:label="$t('infoGen.ville')"
					:required="$siteconf?.mandatory_fields?.city"
					:class="{'pe-none': isDisabled}"
				/>
			</div>
			<MatInput
				v-model="personalInfo.address"
				dense
				:label="$t('infoGen.adress')"
				:required="$siteconf?.mandatory_fields?.address"
				:class="{'pe-none': isDisabled}"
				class=" mb-4"
			/>
			<span
				class="d-flex flex-vertical-center mb-4"
				v-if="this.$siteconf.cooptation && this.$siteconf.cooptation_consent_required"
			>
				<MatCheckbox
					v-model="accept"
					id="acceptTerms"
				/>
				<label for="acceptTerms">
					{{ $t('accept') }} <a
						class="body1 text-center under"
						:href="$siteconf.policy_link || '/privacy'"
						target="_blank"
					>{{ $t('cond') }}</a>
				</label>
			</span>
			<div
				class="pb-4 d-flex flex-column "
				:class="{'d-none': $route.name=='userDetail' }"
			> 
				<div class="d-flex flex-row justify-content-center">
					<MatButton
						outlined
						:label="$t('return')"
						@click="onPrevClick"
						class="me-4"
					/>
					<MatButton
						v-if="form"
						:disabled="invalidForm || (this.$siteconf.cooptation && this.$siteconf.cooptation_consent_required&& !accept)"
						raised
						:label="$t('suiv')"
						@click="onNextClick"
					/>
					<MatButton
						v-if="!form"
						:disabled="invalidForm || clicked"
						raised
						:label="labelBtn"
						@click="nextStep"
					/>
				</div>
			</div>
		</span>
	</ParentForm>
</template>
<script>

import { ROUTES_NAME } from "@/router"
import { Countries, Genders } from "@/utils/constants"
const verifphone = /^[+\d]\d{5,}$/

export default {
	emits: ['updateCandidData', 'updateUser'],
	data() {
		return {
			personalInfo: {},
			countries: Countries,
			genders: Genders,
			cp: {
				type: null
			},
			clicked: false,
			invalidForm: false,
			isDisabled: true,
			birthday: null,
			alreadysend: false,
			firstData: null,
			click: false,
			accept: false
		}
	},
	props: {
		data: {
			type: Object,
			default: () => null
		},
		onNextClick: {
			type: Function,
			default: () => () => alert("next")
		},
		onPrevClick: {
			type: Function,
			default: () => () => alert("prev")
		},
		form: {
			type: Boolean,
			default: () => true
		},
		checkAccount: {
			type: Object,
			default: () => null
		}
	},
	watch: {
		data() {
			this.personalInfo = this.data;
		},
		modelValue: {
			handler() {
				this.value = this.modelValue;
			},
			immediate: true,
		},
		personalInfo: {
			handler() {
				if (this.$route.name == ROUTES_NAME.POST) {
					this.$userData(null, 'contact', this.personalInfo);
					this.updateCp();
					this.invalid();
				}
			},
			deep: true,
		},
		$route: {
			handler() {
				if (this.$route.name == ROUTES_NAME.POST) this.isDisabled = false
			}, immediate: true
		},
	},
	async mounted() {
		this.personalInfo = this.$userData.load('contact', this.data);
		document.body.scrollTop = 0;
		this.firstData = JSON.parse(JSON.stringify(this.personalInfo));
	},

	methods: {
		updateCp() {
			const t = this;
			const country = Countries.find(c => c.key === t.personalInfo.country);
			if (country && country.cp) this.cp = country.cp;
			else this.cp = { type: 'text', minLen: 2, maxLen: 10, rx: ".{2,10}" };
		},

		nextStep() {
			this.clicked = true;
			this.onNextClick();
		},
		invalid() {
			if (!this.personalInfo?.firstName) { this.invalidForm = true }
			else if (!this.personalInfo?.lastName) { this.invalidForm = true }
			else if (!this.personalInfo?.birthday && this.$siteconf?.mandatory_fields?.birthday) { this.invalidForm = true }
			else if (!this.personalInfo?.gender && this.$siteconf?.mandatory_fields?.gender) { this.invalidForm = true }
			else if (!this.personalInfo?.city && this.$siteconf?.mandatory_fields?.city) { this.invalidForm = true }
			else if (!this.personalInfo?.country && this.$siteconf?.mandatory_fields?.country) { this.invalidForm = true }
			else if (!this.personalInfo?.address && this.$siteconf?.mandatory_fields?.address) { this.invalidForm = true }
			else if (!this.personalInfo?.cp && this.$siteconf?.mandatory_fields?.zipcode) { this.invalidForm = true }
			else if (this.personalInfo?.cp && this.cp?.type) {
				if (this.cp?.type === 'text') {
					this.invalidForm = (typeof this.personalInfo.cp !== 'string' || (this.cp.minLen && this.cp.minLen > this.personalInfo.cp.length)
						|| (this.cp.maxLen && this.cp.maxLen < this.personalInfo.cp.length)
						|| !(this.cp.rx && new RegExp(this.cp.rx).test(this.personalInfo.cp)))
				} else if (this.cp?.type === 'number') {
					this.invalidForm = !(this.cp.rx && new RegExp(this.cp.rx).test(this.personalInfo.cp))
				}
			}
			else if ((this.$siteconf.contact_choice == 'both' || this.$siteconf.contact_choice == 'phone') &&
				((this.personalInfo.phone && !verifphone.exec(this.personalInfo.phone)) || !this.personalInfo.phone)) { this.invalidForm = true }
			else this.invalidForm = false

		},

		editform(type) {
			//edit: show edit form 
			if (type == 'edit') { this.isDisabled = !this.isDisabled }
			else if (type == 'cancelUpdate') {
				this.isDisabled = true
				this.personalInfo = this.firstData;
				this.$userData(null, 'contact', this.personalInfo);
				this.firstData = JSON.parse(JSON.stringify(this.personalInfo));
			}
			else if (type == 'update') {
				let obj = JSON.parse(JSON.stringify(this.personalInfo))
				obj = this.prepareCandidateInfo(obj)
				this.$emit("updateUser", { "contact": obj });
				let user = {}
				user.personal = this.personalInfo
				this.$utils.updateUserStorage(user)
				this.isDisabled = true
				this.firstData = JSON.parse(JSON.stringify(this.formdata));
			}
		},

		prepareCandidateInfo(obj) {
			const candidate = {};
			if (obj.firstName) candidate.firstname = obj.firstName;
			if (obj.lastName) candidate.lastname = obj.lastName;
			if (obj.address || obj.city || obj.country || obj.cp) {
				candidate.location = this.$utils.location(obj);
			}
			if (obj.gender) candidate.gender = obj.gender || "";
			if (obj.birthday) candidate.birthday = obj.birthday ? this.$utils.getYearMonthDay(new Date(obj.birthday)) : null;
			if (obj.picture) candidate.photo = obj.picture;
			if (obj.phone) candidate.phone = obj.phone;
			return candidate;
		},

		async verifyAccount() {
			this.$toMove.isSendLinkClicked = true
			try {
				await this.$service.appservice.retryAccount()
				this.alreadysend = true
			} catch (error) {
				console.log("error while sending the mail");
			}
		},

	},
	computed: {
		labelBtn() {
			if (this.clicked) return this.$t('waiting');
			else return this.$t('soumettreCandi')
		},
		maxDate() {
			const today = new Date();
			const maxDate = new Date();
			// Subtract 15 years from today
			maxDate.setFullYear(today.getFullYear() - 15);
			return maxDate.toISOString().slice(0, 10);
		}
	},
}

</script>
<style lang="scss" scoped>
.picture {
	width: 85px;

	.pic-add {
		position: absolute;
		right: -20px;
		bottom: 0;
	}
}

.bg {
	background: rgba(0, 0, 0, 0.08);
	border-radius: 10px !important;
}

.mini {
	font-size: 45px !important;
}

.img {
	width: -webkit-fill-available;
	height: -webkit-fill-available;
	border-radius: 10px !important;
}
</style>
